import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

// 灰度发布配置获取-供应商库选择配置 (中江国际)
export function getZjgjInquirySrmApi() {
  return request({
    url: baseUrl + `/workbench/grayscale/srm-select/zjgj`,
    method: 'get'
  })
}

/** ***********供应商库************** */
const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询供应商库分组
export function getSupplierLibSortApi(params = {}) {
  return request({
    url: baseUrl + '/workbench/enterprise-suppliers/categories',
    method: 'get',
    params
  })
}

// 新增供应商库分组
export function addSupplierLibSortApi(data) {
  return request({
    url: baseUrl + '/workbench/enterprise-suppliers/categories',
    method: 'post',
    data
  })
}

// 更新供应商库分组
export function updateSupplierLibSortApi(data) {
  const { categoryId, ...other } = data
  return request({
    url: baseUrl + `/workbench/enterprise-suppliers/categories/${categoryId}`,
    method: 'put',
    data: other
  })
}

// 删除供应商库分组
export function deleteSupplierLibSortApi(categoryId) {
  return request({
    url: baseUrl + `/workbench/enterprise-suppliers/categories/${categoryId}`,
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 根据供应商分组分页查询供应商（名单）列表
export function getSupplierListByLibSortApi(params) {
  return request({
    url: baseUrl + `/workbench/enterprise-suppliers/page`,
    method: 'get',
    params
  })
}

// 根据供应商分组分页查询供应商（名单）列表
export function getSupplierListByLibSortV2Api(params) {
  return request({
    url: baseUrl + `/workbench/v2/enterprise-suppliers/page`,
    method: 'get',
    params
  })
}

// 更换供应商库名单所在分组
export function changeSupplierSortApi(data) {
  const { listedId, supplierId, ...other } = data
  return request({
    url:
      baseUrl +
      `/workbench/enterprise-suppliers/${listedId}/suppliers/${supplierId}/change-category`,
    method: 'put',
    data: other
  })
}

// 移除供应商库名单所在分组
export function removeSupplierSortApi(data) {
  return request({
    url:
      baseUrl +
      `/workbench/enterprise-suppliers/${data.listedId}/suppliers/${data.supplierId}/out`,
    method: 'put'
  })
}

// 下载证件
export function downloadAllCertApi(data) {
  const { orderId, listedId, supplierId } = data
  return (
    baseUrl +
    `/workbench/enterprise-suppliers/${orderId}/${listedId}/suppliers/${supplierId}/down-cert`
  )
}

// 下载品目
export function downloadAllMaterielApi(query) {
  return (
    baseUrl +
    `/workbench/enterprise-suppliers/${query.listedId}/suppliers/${query.supplierId}/down-materiel`
  )
}

// 查询在库供应商名单列表
export function getCompanySupplierList(params) {
  return request({
    url: baseUrl + '/workbench/enterprise-suppliers/normal/page',
    method: 'get',
    params
  })
}

// 查询共享库列表
export function getSupplierSharedCategoriesApi(params) {
  return request({
    url: baseUrl + '/workbench/enterprise-suppliers/shared/categories',
    method: 'get',
    params
  })
}

// 根据共享供应商分组分页查询供应商（名单）列表
export function getSupplierSharedPageListApi(params = {}) {
  return request({
    url: baseUrl + '/workbench/enterprise-suppliers/shared/categories/page',
    method: 'get',
    params
  })
}

// 分页查询共享供应商列表
export function getSupplierSharedPageListV2Api(params = {}) {
  return request({
    url: baseUrl + '/workbench/v2/enterprise-suppliers/shard/page',
    method: 'get',
    params
  })
}

// 共享供应商分组
export function setSharedSupplierCategoryApi(data) {
  return request({
    url:
      baseUrl +
      '/workbench/enterprise-suppliers/shared/categories/sharedSupplierCategory',
    method: 'post',
    data
  })
}

// 分页查询操作记录
export function getSharedOperatorRecordPageListApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/enterprise-suppliers/shared/categories/findSharedOperatorRecord',
    method: 'get',
    params
  })
}

// 查询当前用户所在集团的所有公司
export function getFindAffiliatedGroupAllCompanyApi() {
  return request({
    url:
      baseUrl +
      '/workbench/enterprise-suppliers/shared/categories/findAffiliatedGroupAllCompany',
    method: 'get'
  })
}

// 供应商出入库信息
export function getSupplierInOutInfoApi(params) {
  const { listedId, supplierId } = params
  return request({
    url:
      baseUrl +
      `/workbench/enterprise-suppliers/${listedId}/${supplierId}/in-out`,
    method: 'get'
  })
}

// 供应商出入库信息
export function getSupplierInOutInfoV2Api(params) {
  const { listedId, supplierId } = params
  return request({
    url:
      baseUrl +
      `/workbench/v2/enterprise-suppliers/${listedId}/${supplierId}/in-out`,
    method: 'get'
  })
}

// 撤销移出分组
export function revokeRemoveSupplierSortApi(listedId, supplierId) {
  return request({
    url:
      baseUrl +
      `/workbench/enterprise-suppliers/${listedId}/suppliers/${supplierId}/cancel`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 导出供应商列表
export function exportSupplierListApi(data) {
  window.open(
    addQueryToUrl(`${baseUrl}/workbench/enterprise-suppliers/page/export`, data)
  )
}

// 导出供应商列表
export function exportSupplierListV2Api(data) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/enterprise-suppliers/supplier/export`,
      data
    )
  )
}

// 导出共享库供应商列表
export function exportShareSupplierListApi(data) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/enterprise-suppliers/shared/categories/page/export`,
      data
    )
  )
}

// 导出共享库供应商列表
export function exportShareSupplierListV2Api(data) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/enterprise-suppliers/shared/export`,
      data
    )
  )
}

// 查询在库供应商名单列表
export function getSelectedSupplierListApi(params) {
  return request({
    url: baseUrl + `/workbench/enterprise-suppliers/normal/page`,
    method: 'get',
    params
  })
}

// 供应商更新评分记录
export function setSupplierScoreV2Api(data) {
  const { listSupplierId, ...other } = data
  return request({
    url:
      baseUrl +
      `/workbench/v2/enterprise-suppliers/${listSupplierId}/listSupplier`,
    method: 'post',
    data: other
  })
}

// 供应商直接入库
export function setSupplierListApi(data) {
  return request({
    url: baseUrl + `/workbench/enterprise-suppliers/addSupplierList`,
    method: 'post',
    data: data
  })
}
